import { inject, Injectable } from '@angular/core';

import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import { SpamVerificationDialogComponent } from '../containers/spam-verification-dialog/spam-verification-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class SpamVerificationDialogService {
  private dialogService = inject(DialogService);
  public open() {
    return this.dialogService.openCustom(
      SpamVerificationDialogComponent,
      { width: DialogWidth.SmallXX },
      {},
    );
  }
}
